import { filesFromDrop } from "@/components/ui/filePickerAccept";

export const SALES_ORDER_ATTACHMENT_ACCEPT =
  "application/pdf,image/*,.pdf,.png,.jpg,.jpeg,.webp";

export function dragEventHasFiles(types: ArrayLike<string>): boolean {
  return Array.from(types).some((type) => type.toLowerCase() === "files");
}

export function salesOrderAttachmentFilesFromDrop(files: ArrayLike<File>): File[] {
  return filesFromDrop(files, {
    accept: SALES_ORDER_ATTACHMENT_ACCEPT,
    multiple: true,
  });
}
